//basic
import React from 'react';
import { toJS } from 'mobx';
import { observer, inject } from 'mobx-react';

//api
import { api } from '../../../functions/api';

//custom components
import CustomInput from '../../../components/basic/input';
// import CustomButton from '../../../components/basic/CustomButton';
// import CustomAvatar from '../../../components/basic/customAvatar';
// import SelectSearch from '../../../components/basic/SelectSearch/SelectSearch';

//material-ui
import { Dialog, DialogTitle, DialogContent, DialogActions,  Button, CircularProgress, Grid, createMuiTheme, MuiThemeProvider } from '@material-ui/core';

//style
import './BillingDeliveryDetail.scss';

const theme = createMuiTheme({
    typography: {
        useNextVariants: true
    },
    overrides: {
        MuiFormControl: {
            root: {
                width: "100%",
            }
        },
        MuiFormLabel: {
            root: {
                color: "rgba(0, 0, 0, 0.54) !important"
            },
            focused: {
                color: "rgba(0, 0, 0, 0.54) !important"
            }
        },
        MuiInput: {
            underline: {
                "&:after": {
                    borderBottomColor: "rgba(0, 0, 0, 0.54) !important"
                }
            },
            disabled: {
                color: "black",
                "&:before": {
                    borderBottomStyle: 'solid !important',
                    borderBottomColor: "black"
                }
            }
        }
    }
})


@inject('translate')
@inject('internal')
@observer
export default class BillingDeliveryDetail extends React.Component {
    constructor(props) {
        super(props);
        this.state={
            loadingBtn: false,
            // loading: true,
            data: {}
        }
    }

    componentDidMount () {
        this.setState({data: this.props.data})

        // let actionEdit = toJS(this.props.internal.actionEdit)

        // if(actionEdit.id !== null) {
        //     Promise.all([
        //         this.loadCustoemrDetail(actionEdit.id ),
        //         // this.loadCountries()
        //     ]).then(() => {
        //         this.setState({loading: false})
        //     })
        
        // }
        // else {
        //     Promise.all([
        //         // this.loadCountries()
        //     ]).then(() => {
        //         this.setState({loading: false})
        //     })
        // }
        
    }

    loadCustoemrDetail = async(idCustomer) => {
        let load_data = await api({
            method: 'get',
            url: `customers/${idCustomer}`,
            authorization: this.props.internal.user.access_token,
        })

        if(load_data.success === true) {
            this.setState({data: load_data.data.data})
        }
    }

    loadCountries = async() => {
        let load_countries = await api ({
            method: 'GET',
            url: 'countries',
            authorization: this.props.internal.user.access_token,
        })

    }

    action = () => {
        this.setState({loadingBtn: true})
        this.updateCustomerData()
    }

    updateCustomerData = async() => {
        
        let idCustomer = toJS(this.props.internal.actionEdit.id)

        // TODO: vymazat ked budu testovacie data
        // idCustomer = 2;

        let data = {}
        if(this.billing_city.state.value !== "") {
            data.billing_city = this.billing_city.state.value
        }

        if(this.state.data.data.billing_country_id) {
            data.billing_country_id = this.state.data.data.billing_country_id
        }

        // if(this.billing_country_id.state.value !== "") {
        //     data.billing_country_id = this.billing_country_id.state.value
        // }

        // if(this.billing_email.state.value !== "") {
        //     data.billing_email = this.billing_email.state.value
        // }

        if(this.billing_phone.state.value !== "") {
            data.billing_phone = this.billing_phone.state.value
        }

        if(this.billing_street.state.value !== "") {
            data.billing_street = this.billing_street.state.value
        }

        if(this.billing_zip.state.value !== "") {
            data.billing_zip = this.billing_zip.state.value
        }

        if(this.delivery_city.state.value !== "") {
            data.delivery_city = this.delivery_city.state.value
        }

        if(this.state.data.data.delivery_country_id) {
            data.delivery_country_id = this.state.data.data.delivery_country_id
        }

        // if(this.delivery_country_id.state.value !== "") {
        //     data.delivery_country_id = this.delivery_country_id.state.value
        // }

        // if(this.delivery_email.state.value !== "") {
        //     data.delivery_email = this.delivery_email.state.value
        // }

        if(this.delivery_phone.state.value !== "") {
            data.delivery_phone = this.delivery_phone.state.value
        }

        if(this.delivery_street.state.value !== "") {
            data.delivery_street = this.delivery_street.state.value
        }

        if(this.delivery_zip.state.value !== "") {
            data.delivery_zip = this.delivery_zip.state.value
        }

        let params = {
            first_name: this.first_name.state.value,
            last_name: this.last_name.state.value,
            email: this.email.state.value,
            data: data
        }

        let update_data = await api({
            method: 'patch',

            // TODO: vymazat ked budu testovacie
            // postman: true,

            url: `customers/${idCustomer}`,
            authorization: this.props.internal.user.access_token,
            params: params
        })

        if (update_data.success === true) {
            this.props.internal.setSnackbar(update_data.data.message, true)
            this.props.onClose(true)
        } else {
            this.props.internal.setSnackbar(update_data.data.message, true)
        }
        
        this.setState({loadingBtn: false})
    }


    handleChangePhoto = async (data) => {
        let idFixedSet = toJS(this.props.internal.actionEdit.id)

        if(idFixedSet !== null) {
            this.setState({loadingBtn: true})
            let upload_data = await api({
                method: 'post',
                url: `products/static-sets/${idFixedSet}`,
                formData: true,

                authorization: this.props.internal.user.access_token,
                params: {
                    photo: data
                },

            })

            if (upload_data.success && upload_data.success === true) {
                // this.props.internal.photoWasChanged(false)
                this.props.internal.setSnackbar(upload_data.data.message, true)
                this.setState({loadingBtn: false})
                
                return Promise.resolve(false)
            }
            else {
                this.props.internal.setSnackbar(upload_data.data.message, true)
            }
        }
        else {

        }
    }

    handleCountry = (field, val) => {
        let tmpData = this.state.data
        tmpData.data[field] = val.target.value
        this.setState({data: tmpData})
    }

    render() {
        let billing_equals_delivery = this.state.data.billing_equals_delivery;
        return (
            <MuiThemeProvider theme={theme}>
            <Dialog
                open={this.props.open}
                onClose={() => this.props.onClose(false)}
                aria-labelledby="form-dialog-title"
                classes={{
                    root: "addEditFixedSetDialog-root",
                    paper: "addEditFixedSetDialog-paper"
                }}
            >
                <DialogTitle id="form-dialog-title">{this.props.title}</DialogTitle>
                {this.state.loading
                ?
                <div style={{minHeight: "100px"}}>
                    <CircularProgress className={'circular-progress'} />
                </div>
                :
                <DialogContent classes={{root: "updateCustomer"}}>
                    <Grid container spacing={8}>
                        
                        <Grid item xs={12} sm={billing_equals_delivery === true ? 12 : 6}>
                            <Grid container>
                                <Grid item xs={12} >
                                    <h2 className={'titleAddress'}>{this.props.translate.i18n.MODULES.CUSTOMERS.BILLING_ADDRESS}</h2>
                                </Grid>
                                <Grid item xs={12}>
                                    <CustomInput
                                        ref={ref => this.billing_first_name = ref}
                                        text={this.props.translate.i18n.GLOBAL.USER.FIRST_NAME}
                                        value={this.state.data.billing_phone !== null ? this.state.data.billing_first_name : ""}
                                        id={'billing_first_name'}
                                        className={"w-100"}
                                        disabled
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <CustomInput
                                        ref={ref => this.billing_last_name = ref}
                                        text={this.props.translate.i18n.GLOBAL.USER.LAST_NAME}
                                        value={this.state.data.billing_last_name !== null ? this.state.data.billing_last_name : ""}
                                        id={'billing_last_name'}
                                        className={"w-100"}
                                        disabled
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <CustomInput
                                        ref={ref => this.billing_company_name = ref}
                                        text={this.props.translate.i18n.MODULES.CUSTOMERS_ORDERS.COMPANY_NAME}
                                        value={this.state.data.billing_company_name !== null ? this.state.data.billing_company_name : ""}
                                        id={'billing_company_name'}
                                        className={"w-100"}
                                        disabled
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <CustomInput
                                        ref={ref => this.billing_id_no = ref}
                                        text={this.props.translate.i18n.MODULES.CUSTOMERS_ORDERS.ID_NO}
                                        value={this.state.data.billing_id_no !== null ? this.state.data.billing_id_no : ""}
                                        id={'billing_id_no'}
                                        className={"w-100"}
                                        disabled
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <CustomInput
                                        ref={ref => this.billing_id_tax = ref}
                                        text={this.props.translate.i18n.MODULES.CUSTOMERS_ORDERS.ID_TAX}
                                        value={this.state.data.billing_id_tax !== null ? this.state.data.billing_id_tax : ""}
                                        id={'billing_id_tax'}
                                        className={"w-100"}
                                        disabled
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <CustomInput
                                        ref={ref => this.billing_id_vat = ref}
                                        text={this.props.translate.i18n.MODULES.CUSTOMERS_ORDERS.ID_VAT}
                                        value={this.state.data.billing_id_vat !== null ? this.state.data.billing_id_vat : ""}
                                        id={'billing_id_vat'}
                                        className={"w-100"}
                                        disabled
                                    />
                                </Grid>
                                
                                <Grid item xs={12}>
                                    <CustomInput
                                        ref={ref => this.billing_street = ref}
                                        text={this.props.translate.i18n.GLOBAL.ADRESS.ADRESS}
                                        value={this.state.data !== null ? this.state.data.billing_street : ""}
                                        id={'billing_street'}
                                        className={"w-100"}
                                        disabled
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <CustomInput
                                        ref={ref => this.billing_zip = ref}
                                        text={this.props.translate.i18n.GLOBAL.ADRESS.ZIP}
                                        value={this.state.data !== null ? this.state.data.billing_zip : ""}
                                        id={'billing_zip'}
                                        className={"w-100"}
                                        disabled
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <CustomInput
                                        ref={ref => this.billing_city = ref}
                                        text={this.props.translate.i18n.GLOBAL.ADRESS.CITY}
                                        value={this.state.data !== null ? this.state.data.billing_city : ""}
                                        id={'billing_city'}
                                        className={"w-100"}
                                        disabled
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <CustomInput
                                        ref={ref => this.billing_country_name = ref}
                                        text={this.props.translate.i18n.GLOBAL.ADRESS.COUNTRY}
                                        value={this.state.data !== null ? this.state.data.billing_country_name : ""}
                                        id={'billing_country_name'}
                                        className={"w-100"}
                                        disabled
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <CustomInput
                                        ref={ref => this.billing_phone = ref}
                                        text={this.props.translate.i18n.GLOBAL.CONTACT.PHONE}
                                        value={this.state.data.billing_phone !== null ? this.state.data.billing_phone : ""}
                                        id={'billing_phone'}
                                        className={"w-100"}
                                        disabled
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <CustomInput
                                        ref={ref => this.billing_email = ref}
                                        text={this.props.translate.i18n.GLOBAL.CONTACT.EMAIL}
                                        value={this.state.data.billing_email !== null ? this.state.data.billing_email : ""}
                                        id={'billing_email'}
                                        className={"w-100"}
                                        disabled
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <CustomInput
                                        multiline
                                        ref={ref => this.note = ref}
                                        text={this.props.translate.i18n.GLOBAL.CONTACT.NOTE}
                                        value={this.state.data.note !== null ? this.state.data.note : ""}
                                        id={'note'}
                                        className={"w-100"}
                                        disabled
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        {this.state.data.billing_equals_delivery === false ?
                            <Grid item xs={12} sm={6}>
                                <Grid container>
                                    <Grid item xs={12} >
                                        <h2 className={'titleAddress'}>{this.props.translate.i18n.MODULES.CUSTOMERS.DELIVERY_ADDRESS}</h2>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <CustomInput
                                            ref={ref => this.delivery_first_name = ref}
                                            text={this.props.translate.i18n.GLOBAL.USER.FIRST_NAME}
                                            value={this.state.data.delivery_first_name !== null ? this.state.data.delivery_first_name : ""}
                                            id={'delivery_first_name'}
                                            className={"w-100"}
                                            disabled
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <CustomInput
                                            ref={ref => this.delivery_last_name = ref}
                                            text={this.props.translate.i18n.GLOBAL.USER.LAST_NAME}
                                            value={this.state.data.delivery_last_name !== null ? this.state.data.delivery_last_name : ""}
                                            id={'delivery_last_name'}
                                            className={"w-100"}
                                            disabled
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <CustomInput
                                            ref={ref => this.delivery_street = ref}
                                            text={this.props.translate.i18n.GLOBAL.ADRESS.ADRESS}
                                            value={this.state.data !== null ? this.state.data.delivery_street : ""}
                                            id={'delivery_street'}
                                            className={"w-100"}
                                            disabled
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <CustomInput
                                            ref={ref => this.delivery_zip = ref}
                                            text={this.props.translate.i18n.GLOBAL.ADRESS.ZIP}
                                            value={this.state.data !== null ? this.state.data.delivery_zip : ""}
                                            id={'delivery_zip'}
                                            className={"w-100"}
                                            disabled
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <CustomInput
                                            ref={ref => this.delivery_city = ref}
                                            text={this.props.translate.i18n.GLOBAL.ADRESS.CITY}
                                            value={this.state.data !== null ? this.state.data.delivery_city : ""}
                                            id={'delivery_city'}
                                            className={"w-100"}
                                            disabled
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <CustomInput
                                            ref={ref => this.delivery_country_name = ref}
                                            text={this.props.translate.i18n.GLOBAL.ADRESS.COUNTRY}
                                            value={this.state.data !== null ? this.state.data.delivery_country_name : ""}
                                            id={'delivery_country_name'}
                                            className={"w-100"}
                                            disabled
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <CustomInput
                                            ref={ref => this.delivery_phone = ref}
                                            text={this.props.translate.i18n.GLOBAL.CONTACT.PHONE}
                                            value={this.state.data !== null ? this.state.data.delivery_phone : ""}
                                            id={'delivery_phone'}
                                            className={"w-100"}
                                            disabled
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <CustomInput
                                            ref={ref => this.delivery_email = ref}
                                            text={this.props.translate.i18n.GLOBAL.CONTACT.EMAIL}
                                            value={this.state.data !== null ? this.state.data.delivery_email : ""}
                                            id={'delivery_email'}
                                            className={"w-100"}
                                            disabled
                                        />
                                    </Grid>
                                    
                                </Grid>
                            </Grid>
                            :
                            null
                        }
                    </Grid>
                    
                </DialogContent>
                }
                <DialogActions>
                    <Button onClick={() => this.props.onClose(false)} className={'gray-text'}>
                        {this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}
                    </Button>
                    {/* <CustomButton
                        progressBar={this.state.loadingBtn}
                        onClick={this.action}
                        mystyle={'btn-white-bg'}
                        title={this.props.translate.i18n.GLOBAL.BUTTONS.SAVE}
                        justText
                        disabled={this.state.loading}
                    /> */}
                </DialogActions>
            </Dialog>
            </MuiThemeProvider>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/CustomersOrders/BillingDeliveryDetail/BillingDeliveryDetail.jsx